import { Component } from '@angular/core';
import { StatusBar } from '@capacitor/status-bar';
import { Platform, PopoverController, MenuController, ModalController } from '@ionic/angular';
import { PlanesComponent } from './components/landing/planes/planes.component';
import { RegisterComponent } from './components/register/register.component';
import { LoginService } from './services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private popoverController: PopoverController,
    private menuController: MenuController,
    private modalController: ModalController,
    private loginService: LoginService,
  ) {

    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {

    });
  }
  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: PlanesComponent,
      event: ev,
      translucent: false
    });
  
    await popover.present();
  }
  async presentLoginModal() {
    const modal = await this.modalController.create({
    component: RegisterComponent,
    cssClass:'modalLogin glassEffect'
    });
  
    await modal.present();
    this.closeMenu();
  
  }

  closeMenu(){
    this.menuController.close('mobilelandin')
  }
}
